import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { withApp } from '@brainstud/react-tbl/themes/pgw/v1/helpers'
import { selectChapter } from './selectors'
import { setProgress as setNavigationProgress } from '@brainstud/react-tbl/features/navigation/store/actions'

const withChapter = Component => props => {
  const { dispatch, staticContext, ...rest } = props

  return <Component {...rest} />
}

const mapProps = (state, props) => {
  const chapter = selectChapter(state, props)

  return { chapter }
}

const mapActions = (dispatch) => {
  return {
    setNavigationProgress: params => dispatch(setNavigationProgress(params)),
  }
}

export default compose(
  connect(mapProps, mapActions),
  withApp,
  withChapter,
)
